import React from 'react';
import { ParentalPinManagementForm } from '../components/ui/ParentalPinManagementForm';

type ParentalPinManagementScreenProps = {
    screenName: string;
    screenKey: string;
};

export const ParentalPinManagementScreen: React.FC<ParentalPinManagementScreenProps> = ({ screenName, screenKey }) => {
    return (
        <>
            <ParentalPinManagementForm />
        </>
    );
};
